var updatedValue = 1;

$(document).on('change', '.getinputnumber', function() {
  updatedValue = $(this).val().replace(/[^0-9]/g, '');
  $(this).val(updatedValue);
  console.log(updatedValue, "updatedValue");
});

$(document).on('focusout', '.getinputnumber', function() {
  let updatedValue = parseInt($(this).val(), 10);

  if (isNaN(updatedValue) || updatedValue < 1) {
    updatedValue = 1;
    $(this).val(updatedValue);
  }

  let cardCurated = $(this).closest('.card-curated')[0];
  if (!cardCurated) {
    console.warn('cardCurated not found');
    return;
  }

  let editButton = cardCurated.querySelector('.edit-btn');
  let basePrice = parseFloat(editButton.dataset.price);

  if (!basePrice) {
    let priceText = editButton.textContent.replace(/[₹,]/g, '');
    basePrice = parseFloat(priceText);
    editButton.dataset.price = basePrice;
  }

  let calculatedPrice = basePrice * updatedValue;
  let formattedPrice = '₹' + parseFloat(calculatedPrice.toFixed(2)).toLocaleString('en-IN');
  editButton.textContent = formattedPrice;
});

$(document).on('click', '.buttons-curated .button-ATC', function() {
  var qty = $(this).closest('.buttons-curated').find('[name="quantity"]');
  qty.val(updatedValue);
});

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  document.addEventListener('click', (event) => {
    if (event.target.classList.contains('choose-btn-customized')) {
      const getPopUp = event.target.closest('.main-parent-customization')?.querySelector('.customizable-product');
      if (getPopUp) {
        getPopUp.classList.remove('popupopen');
        body.classList.add('overlay-hidden');
      }
    }

    if (event.target.classList.contains('close-popup')) {
      const closepopup = event.target.closest('.main-parent-customization')?.querySelector('.customizable-product');
      if (closepopup) {
        closepopup.classList.add('popupopen');
        body.classList.remove('overlay-hidden');
      }
    }
  });
});

// catalogue download button
   document.addEventListener('DOMContentLoaded', () => {
      let downloadBtnn = document.querySelector('#downloadBtnnn');
      if(downloadBtnn){
    downloadBtnn.addEventListener('click', function(e) {
         let getdata = this.getAttribute("fetchimg");
      let targetFileName = getdata.split('/').pop().split('?')[0].split('.')[0];
         fetch(getdata).then(response => response.blob()).then(blob => {
             const blobURL = URL.createObjectURL(blob);
           const link = document.createElement('a');
             link.href = blobURL;
             link.download = `${targetFileName}.pdf`;
             link.click();
             setTimeout(() => URL.revokeObjectURL(blobURL), 100);
         }).catch(error => console.error('Download error:', error));
     });
     }
  });
  
// catalogue download button
  
